import { useState } from "react";
import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

const PIN_LENGTH = 6;

const KEYPAD_ROWS = [
  [1, 2, 3],
  [4, 5, 6],
  [7, 8, 9],
  [null, 0, "delete"],
];

const Login = (props) => {
  const [pin, setPin] = useState("");
  const [pinError, setPinError] = useState("");

  const handleKeyPress = (key) => {
    setPinError("");
    if (key === "delete") {
      setPin((prev) => prev.slice(0, -1));
    } else if (typeof key === "number" && pin.length < PIN_LENGTH) {
      setPin((prev) => prev + String(key));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setPinError("");
    if (pin.length !== 6) {
      setPinError("Please enter a 6-digit PIN.");
      return;
    }
    props.onAuthWithPin(pin);
  };

  const errorMessage = props.error?.subtitle || props.error?.title || pinError;

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-indigo-50/30 flex flex-col">
      <div className="flex-1 flex flex-col justify-center px-4 py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-xl">
          <div className="bg-white rounded-2xl shadow-xl shadow-slate-200/50 p-8 sm:p-10">
          <h2 className="text-center text-3xl sm:text-4xl font-bold tracking-tight text-slate-800">
            Solmaz Foods Campaigns
          </h2>
          <p className="mt-3 text-center text-slate-500 sm:text-slate-600">
            Enter your 6-digit PIN
          </p>

          <form className="mt-4 space-y-6" onSubmit={handleSubmit}>
            <div>
              <div className="flex justify-center gap-2 sm:gap-3">
                {[...Array(PIN_LENGTH)].map((_, index) => (
                  <div
                    key={index}
                    className="min-h-[3rem] min-w-[3rem] sm:min-h-14 sm:min-w-14 rounded-xl flex items-center justify-center text-xl sm:text-2xl font-semibold ring-2 ring-slate-200 bg-slate-50"
                  >
                    {pin[index] ? "•" : ""}
                  </div>
                ))}
              </div>
              {pinError ? (
                <p className="mt-2 text-sm text-red-500 text-center">{pinError}</p>
              ) : null}
            </div>

            <div className="grid grid-cols-3 gap-3 sm:gap-4">
              {KEYPAD_ROWS.flat().map((key, index) => (
                <button
                  key={index}
                  type="button"
                  onClick={() => key !== null && handleKeyPress(key)}
                  disabled={props.loading || key === null}
                  className={`
                    min-h-[3.5rem] sm:min-h-14 rounded-xl font-semibold text-lg sm:text-xl
                    transition-colors select-none touch-manipulation
                    disabled:opacity-50 disabled:cursor-not-allowed
                    ${key === null ? "invisible" : ""}
                    ${key === "delete"
                      ? "bg-slate-200 text-slate-700 hover:bg-slate-300 active:bg-slate-400"
                      : "bg-slate-100 text-slate-800 hover:bg-slate-200 active:bg-slate-300"
                    }
                  `}
                >
                  {key === "delete" ? "Del" : key}
                </button>
              ))}
            </div>

            <div>
              <button
                type="submit"
                disabled={props.loading}
                className="flex w-full justify-center rounded-xl bg-main-purple px-4 py-3 sm:py-4 text-base font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:opacity-70 disabled:cursor-not-allowed"
              >
                {props.loading ? "Signing in..." : "Sign in"}
              </button>
            </div>
          </form>

          {props.error && !pinError ? (
            <p className="mt-5 text-center text-sm text-red-500">
              {errorMessage}
            </p>
          ) : null}
          </div>
        </div>
      </div>
      <div className="text-center text-sm text-slate-400 py-4">
        powered by <a href="https://qatrace.com/" target="_blank" rel="noopener noreferrer" className="hover:text-slate-200 transition-colors">QAtrace.com</a>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.auth.loading,
    error: state.auth.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onAuthWithPin: (pin) => dispatch(actions.authWithPin(pin)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
